import React from 'react';
import {useSelector} from "react-redux";
import ProductListUi from "./ProductListUi";
import {PRODUCT_LIST_TYPE} from "../../../../constants/commons";

const ProductFeatured = ({mobile}) => {

  const specialData =
    useSelector((state) => state.dynamicMultipleElements.products['featured']);

  return (
    <div className="w-full">
      <ProductListUi productData={specialData} className="pt-2 grid-area min-w-0"
                     title="Featured Products" viewButtonColor="text-dark"
                     type={PRODUCT_LIST_TYPE.featured} mobile={mobile}/>
    </div>

  );
};

export default React.memo(ProductFeatured);
